<!-- eslint-disable max-len -->
<template>
  <header class="site-header pb-0">
    <nav class="site-nav bg-primaryColor">
      <div class="max-w-6xl mx-auto px-2 sm:px-6 lg:px-8">
        <div class="relative flex items-center justify-between h-16">
          <div class="flex-1 flex items-center justify-between sm:items-stretch sm:justify-start">
            <router-link class="flex-shrink-0 flex items-center site-title font-black" to="/">
              <img class="h-8 px-2" :src="logo" alt="Workflow" />
              Implicit
              <span
                class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-pink-100 text-pink-800 italic h-4 self-start font-bold"
                >BETA</span
              >
            </router-link>
            <div class="hidden md:block h-full ml-3">
              <div class="flex items-center h-20">
                <!-- Current: "bg-gray-900 text-white", Default: "text-gray-300 hover:bg-gray-700 hover:text-white" -->
                <a
                  v-if="pathname === '/'"
                  class="text-gray-300 page-link hover:text-white px-3 py-2 rounded-md text-md font-medium cursor-pointer"
                  aria-current="page"
                  @click="setFeedPopup(true)"
                  >Request Access</a
                >
                <router-link
                  v-if="pathname !== '/'"
                  :to="{ path : '/' , query: { setFeedPopup : true }}"
                  class="text-gray-300 page-link hover:text-white px-3 py-2 rounded-md text-md font-medium cursor-pointer"
                  aria-current="page"
                  >Request Access</router-link
                >
                <a
                  v-if="pathname === '/'"
                  class="text-gray-300 page-link hover:text-white px-3 py-2 rounded-md text-md font-medium cursor-pointer"
                  aria-current="page"
                  @click="gotoCourses()"
                  >Product</a
                >
                <router-link
                  v-if="pathname !== '/'"
                  :to="{ path : '/' , query: { product : true }}"
                  class="text-gray-300 page-link hover:text-white px-3 py-2 rounded-md text-md font-medium cursor-pointer"
                  aria-current="page"
                  >Product</router-link
                >
                <router-link
                  to="/about"
                  class="hidden text-gray-300 page-link hover:text-white px-3 py-2 rounded-md text-md font-medium"
                  aria-current="page"
                  >Pricing</router-link
                >
                <router-link
                  to="/about"
                  class="hidden text-gray-300 page-link hover:text-white px-3 py-2 rounded-md text-md font-medium"
                  aria-current="page"
                  >Blog</router-link
                >
                <router-link
                  to="/about"
                  class="hidden text-gray-300 page-link hover:text-white px-3 py-2 rounded-md text-md font-medium"
                  aria-current="page"
                  >More</router-link
                >
              </div>
            </div>
          </div>
          <div class="flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0 hidden md:block">
            <router-link
              class="page-link"
              to="/admin/products"
              v-if="role === 'SUPERADMIN' || role === 'ADMIN' || role === 'COURSE_CREATOR'"
              >Admin</router-link
            >
            <router-link class="page-link text-white" to="/m/login" v-if="!signedIn"
              >Sign In</router-link
            >
            <router-link
              class="page-link bg-white text-black py-3 px-4 rounded-lg"
              to="/m/register"
              v-if="!signedIn"
              >Sign Up</router-link
            >
            <a class="page-link ml-8" v-if="signedIn">{{
              userName
            }}</a>
            <button class="page-link hover:underline" v-if="signedIn" v-on:click="signOut">
              Sign Out
            </button>
          </div>
          <div class="flex items-center md:hidden">
            <!-- Mobile menu button-->
            <button
              type="button"
              class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
              aria-controls="mobile-menu"
              aria-expanded="false"
              @click.prevent="mobileMenu = !mobileMenu"
            >
              <span class="sr-only">Open main menu</span>
              <!--
                Icon when menu is closed.

                Heroicon name: outline/menu

                Menu open: "hidden", Menu closed: "block"
              -->
              <svg
                class="block h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- Mobile menu, show/hide based on menu state. -->
      <div class="md:hidden" :class="mobileMenu ? 'block' : 'hidden'" id="mobile-menu">
        <div class="px-2 pt-2 pb-3 space-y-1">
          <!-- Current: "bg-gray-900 text-white", Default: "text-gray-300 hover:bg-gray-700 hover:text-white" -->
          <a
            v-if="pathname === '/'"
            class="text-gray-300 page-link hover:text-white px-3 py-2 rounded-md text-md font-medium cursor-pointer"
            aria-current="page"
            @click="mobileMenu = !mobileMenu, setFeedPopup(true)"
            >Request Access</a
          >
          <router-link
            v-if="pathname !== '/'"
            :to="{ path : '/' , query: { setFeedPopup : true }}"
            class="text-gray-300 page-link hover:text-white px-3 py-2 rounded-md text-md font-medium cursor-pointer"
            aria-current="page"
            >Request Access</router-link
          >
          <a
            v-if="pathname === '/'"
            class="text-gray-300 page-link hover:text-white px-3 py-2 rounded-md text-md font-medium cursor-pointer"
            aria-current="page"
            @click="mobileMenu = !mobileMenu, gotoCourses()"
            >Product</a
          >
          <router-link
            v-if="pathname !== '/'"
            :to="{ path : '/' , query: { product : true }}"
            class="text-gray-300 page-link hover:text-white px-3 py-2 rounded-md text-md font-medium cursor-pointer"
            aria-current="page"
            >Product</router-link
          >
          <router-link
              class="page-link"
              to="/admin/products"
              v-if="role === 'SUPERADMIN' || role === 'ADMIN' || role === 'COURSE_CREATOR'"
              >Admin</router-link
            >
            <router-link class="page-link text-white" to="/m/login" v-if="!signedIn" @click.native="mobileMenu = !mobileMenu"
              >Sign In</router-link
            >
            <router-link
              class="page-link text-white"
              to="/m/register"
              v-if="!signedIn"
              @click.native="mobileMenu = !mobileMenu"
              >Sign Up</router-link
            >
            <!-- to redirect on profile :href="role === 'SUPERADMIN' || role === 'COURSE_CREATOR' ? (host === 'implicit.io' ? `https://discover.implicit.io/u/${acctUsername}` : `https://staging-course.implicit.io/u/${acctUsername}`) : '/home'" -->
            <a @click="mobileMenu = !mobileMenu" class="page-link"  v-if="signedIn">{{
              userName
            }}</a>
            <a class="page-link" v-if="signedIn" v-on:click="signOut(), mobileMenu = !mobileMenu">
              Sign Out
            </a>
          <!-- <router-link
            to="/about"
            class="bg-gray-900 text-white block px-3 py-2 rounded-md text-base font-medium"
            aria-current="page"
            >About</router-link
          >

          <router-link
            to="/about"
            class="text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium"
            >Products</router-link
          >

          <router-link
            to="/about"
            class="text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium"
            >Pricing</router-link
          >

          <router-link
            to="/about"
            class="text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium"
            >Blog</router-link
          >
          <router-link
            to="/about"
            class="text-gray-300 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium"
            >More</router-link
          > -->
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import firebase from '@implicit-web/auth/src/services/firebase';
import store from '@/store';
import utils from '@/services/utils';
import userInfo from '@/services/userInfo';
import logo from '@/assets/logo_sq.png';

export default {
  name: 'main-header',
  data() {
    return {
      mobileMenu: false,
      signedIn: false,
      chSubscriptions: [],
      userId: null,
      acctUsername: null,
      userName: null,
      email: null,
      pathname: '',
      host: '',
      role: null,
      logo,
    };
  },
  methods: {
    _ensureNavToPath(path) {
      if (this.$router.currentRoute.path !== path) this.$router.push(path);
    },
    setFeedPopup(isOpen) {
      store.commit('updateFeedPopup', isOpen);
    },
    gotoCourses() {
      window.scrollTo(0, document.querySelector('#courses').scrollHeight + 250);
    },
    async signOut() {
      try {
        await firebase.logout(this);
      } catch (e) {
        utils.log('error signing out: ', e);
      }
    },
    async setSignedIn(appUser) {
      if (!appUser || Object.keys(appUser).length === 0 || !appUser.authRes) return;
      const cogUser = appUser.authRes;
      this.signedIn = true;

      if (this.userId && this.userId === cogUser.uid) {
        utils.log('Already signed in');
        return;
      }
      this.userId = cogUser.uid;
      const { user, customToken } = await userInfo.getUserInfo(cogUser.uid);
      this.chSubscriptions = user.chSubscriptions;
      await store.commit('updateChSubscriptions', this.chSubscriptions);
      if (customToken) localStorage.setItem('customToken', user.customToken);
      this.role = user.role ? user.role : null;
      this.acctUsername = user.acctUsername;
      this.userName = user.userName;
      this.email = user.userEmail;
      this.profilePic = user.profilePic;
      const token = await firebase.getAuthToken();
      utils.log(`User '${user.userName}' signed in with channels: `, this.chSubscriptions);
      await store.commit('setSignedIn', {
        user: {
          email: user.userEmail,
          name: user.userName,
          uid: cogUser.uid,
          isVerified: cogUser.emailVerified,
          profilePic: user.profilePic,
        },
        token,
      });
    },
    updateAuth(authRes) {
      this.setSignedIn({ authRes, newUser: false });
    },
    async setSignedOut() {
      this.signedIn = false;
      this.chSubscriptions = [];
      this.userId = null;
      this.userFName = null;
      this.role = null;
      await store.commit('updateChSubscriptions', []);
      if (store.state.user) {
        await store.commit('setLogout');
        if (this.$router.history.current.path !== '/') {
          this.$router.push('/');
        }
      }
    },
  },
  mounted() {
    this.pathname = window.location.pathname;
    console.log(this.pathname);
    this.host = window.location.hostname;
  },
  async beforeCreate() {
    firebase.watchAuthStateChange().then(async (user) => {
      // store.commit('toggleLoading', false);
      if (user) {
        await this.updateAuth(user);
      } else {
        const { customToken } = store.state;
        if (customToken) {
          firebase.loginWithSSO(this, customToken);
        }
        await this.setSignedOut();
      }
    });
  },
};
</script>

<style>
/* nav specific */
.site-header {
  @apply bg-primaryColor text-white;

  border-bottom: 1px solid #e8e8e8;
  min-height: 56px;
  padding: 10px 0px;

  /* Positioning context for the mobile navigation icon */
  position: relative;
}

.site-header a,
.site-header a.site-title {
  @apply text-white;
}

.site-logo {
  height: 40px;
  width: 40px;
  margin-right: 10px;
}

.site-title {
  /* TODO: TailWind implement below line */
  /* font-family: "MetropolisRegular", $base-font-family; */
  font-size: 26px;
  line-height: 56px;
  letter-spacing: -1px;
  margin-bottom: 0;
}
/* should the below be removed? */
.site-title,
.site-title:visited {
  color: #424242;
}

.site-nav .page-link {
  /* color: $text-color; */
  /* color: white; */
  /* color: $brand-color; */
  line-height: 1.45;
}

.sidebar-logo {
  object-fit: contain;
  width: 100%;
  height: 100%;
}

.text-green-900 path {
  stroke: #22543d !important;
}

.text-blue-800 path {
  stroke: #2c5282 !important;
}

/** ==================== */
/** implement site menus */
/** ==================== */
/** common bits */
.site-nav {
  line-height: 56px;
  @apply p-2;
}
/** mobile-only version (menu) */
@media screen and (max-width: theme('screens.sm')) {
  .site-nav {
    /* position: absolute;
    top: 16px;
    right: 30px;
    border: 1px solid #e8e8e8; */
    background-color: theme('colors.backgroundColor');
    border-radius: 5px;
    text-align: right;
  }
  .site-nav .menu-icon {
    display: block;
    float: right;
    /* width: 36px;   */
    /* height: 26px; */
    /* line-height: 0; */
    /* padding-top: 10px; */
    text-align: center;
  }
  .site-nav .menu-icon > svg {
    width: 18px;
    height: 15px;
  }
  .site-nav .menu-icon > svg path {
    /* fill: $grey-color-dark; */
    fill: #424242;
  }

  .site-nav .trigger {
    clear: both;
    display: none;
  }

  .site-nav:hover .trigger {
    display: block;
    padding-bottom: 5px;
  }

  .site-nav .page-link {
    display: block;
    padding: 5px 10px;
  }
}

/** 'desktop' version */
@screen sm {
  .site-nav .menu-icon {
    display: none;
  }

  /* Gaps between nav items, but not on the first one */
  .site-nav .page-link:not(:first-child) {
    margin-left: 20px;
  }
}
</style>
